<template>
  <div class="topfans-toufang-component">
    <div class="topfans-section app-basic-layout-wrapper">
      <h3 class="title font-30">投放方式</h3>
      <p class="subtitle font-color-desc">互动营销新途径，激活潜在兴趣人群</p>
      <div class="body">
        <ul class="tabs">
          <li
            v-for="(item, index) in tabs"
            :key="item.id"
            :class="{ active: activeIndex === index }"
            @click="changeTab(index)"
          >
            <div class="tab-item">{{ item.title }}</div>
          </li>
        </ul>
        <template v-for="(item, index) in tabs">
          <div v-if="activeIndex === index" :key="item.id" class="tab-content">
            <div class="main-content">
              <h3 class="content-title">{{ item.title }}</h3>
              <p class="desc">{{ item.desc }}</p>
              <a
                href="https://weibo.com/u/3587960280"
                class="button"
                target="_blank"
              >
                免费咨询，开始使用
              </a>
            </div>
            <div class="image-wrapper">
              <img :src="item.img" />
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import screen1 from '@/assets/img/topfans/yingxiaotuiguang.gif'
import screen2 from '@/assets/img/topfans/neirongjiare.gif'
import screen3 from '@/assets/img/topfans/bangshangtoutiao.gif'

export default {
  data() {
    return {
      activeIndex: 0,
      tabs: [
        {
          id: 1,
          title: '营销推广',
          desc: '转化变现一步到位，可投放营销性质博文如：店铺产品上新宣传、转发抽奖等，加速提升转化变现效率；',
          img: screen1
        },
        {
          id: 2,
          title: '内容加热',
          desc: '人人都有机会撬动百万流量上【热门】，博文内容要求：无营销性质博文，如观点表达、日常生活分享、专业领域知识分享等；',
          img: screen2
        },
        {
          id: 3,
          title: '帮上头条',
          desc: '快速提升关注，拥有海量粉丝，适用场景：明星大V背书及品牌宣传',
          img: screen3
        }
      ]
    }
  },
  methods: {
    changeTab(index) {
      this.activeIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
.body {
  padding-top: 60px;
  position: relative;
  padding-left: 271px;
  .tabs {
    position: absolute;
    left: 0;
    top: 60px;
    height: 177px;
    border-left: 3px solid rgba(142, 144, 145, 0.25);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .tab-item {
      padding-left: 19px;
      cursor: pointer;
      height: 30px;
      line-height: 30px;
      font-size: 16px;
      position: relative;
    }
    li {
      &.active {
        color: $text-color-primary;
        .tab-item {
          &:after {
            content: '';
            background-color: $text-color-primary;
            position: absolute;
            width: 3px;
            height: 100%;
            left: -3px;
            top: 0;
          }
        }
      }
    }
  }
  .tab-content {
    padding-right: 458px;
    position: relative;
    min-height: 525px;
    .image-wrapper {
      position: absolute;
      right: 0;
      bottom: -88px;
      width: 436px;
      height: 655px;
      overflow: hidden;
      box-sizing: border-box;
      background: url('~@/assets/img/topfans/phone_bg.png') no-repeat top
        center/100% 100%;
      padding: 120px 70.24px 0 76.97px;
      img {
        width: 100%;
        height: 100%;
        float: left;
        object-fit: cover;
        border-radius: 4.8px;
        border: 1px solid #e3e5e9;
      }
    }
    .content-title {
      font-size: 26px;
      line-height: 32px;
      margin-bottom: 52px;
    }
    .desc {
      font-size: 18px;
      margin-bottom: 104px;
      line-height: 36px;
    }
    .button {
      width: 208px;
      height: 48px;
      line-height: 48px;
      font-size: 16px;
      text-align: center;
      color: #ffffff;
      border-radius: 24px;
      background-color: $danger-color;
      display: inline-block;
      cursor: pointer;
    }
  }
}
</style>
